import React from 'react'
import {connect} from 'react-redux'
import {CompanySelector, CompanyModel }from '/app/src/model/Company'
import {CustomizationSelector}from '/app/src/model'
import Modal from 'react-responsive-modal';
import { history } from '/app/src/store'
import {SystemSelector} from '/app/src/model/System'
import { withRouter } from 'react-router-dom'

import MenuSubTitle from '/app/src/component/Menu/SubTitle';
import MenuSubItem  from '/app/src/component/Menu/SubItem';

import {Flex, ToogleSwitch, SVGButton} from '/app/src/component'
import WithPaymentPermission from '/app/src/hoc/withPaymentPermission'

class ClientChatMenu extends React.Component {
    constructor(props){
        super(props)
        this._renderMenu = this._renderMenu.bind(this)

        this._closeModal = this._closeModal.bind(this)
        this._openModal = this._openModal.bind(this)
        this._updateClientchat = this._updateClientchat.bind(this)
        this.state = {
            modalConfirmTurnOffClientChat: false
        }
    }

    _closeModal(){
        this.setState({ modalConfirmTurnOffClientChat: false });
    }
    _openModal(){
        if(this.props.isClientChatAvailable){
            this.setState({modalConfirmTurnOffClientChat: true})
        }else{
            this.props.dispatch(CompanyModel.update({'is_available': true}))
        }
    }
    _updateClientchat(is_available){
        return (event)=> {
            this.props.dispatch(CompanyModel.update({'is_available': is_available}))
        }
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.isClientChatAvailable !== this.props.isClientChatAvailable){
            this.setState({ modalConfirmTurnOffClientChat: false });
        }
    }

    _renderHelpDeskMenuItem() {
        switch(this.props.faqType) {
            case 'helpdesk':
                return <MenuSubItem
                    svgSrc='/images/Menu_ClientChat_Helpdesk_L.svg'
                    text={<span>Helpdesk<sup style={{color: 'purple', marginLeft: '1px'}}>PRO</sup></span>} to='/clientChat/faq/helpdesk'
                    svgfill='#f64b7f'/>
            case 'faq':
                return <MenuSubItem
                    text='FAQ'
                    to='/clientChat/faq'
                    svgSrc='/images/Menu_ClientChatFAQ_L.svg'
                    svgfill='#f64b7f'/>
            default:
                return <MenuSubItem
                    text='FAQ/Helpdesk'
                    to='/clientChat/faq/introduction'
                    svgSrc='/images/Menu_ClientChatFAQ_L.svg'
                    svgfill='#f64b7f'/>
        }
    }

    _renderUpgradeButton() {

        if(this.props.params[2] === 'introduction') return;
        if(this.props.params[1] !== 'faq') return;

        switch(this.props.faqType) {
            case 'helpdesk':
                return (
                    <SVGButton text='Nedgradera till Frågor & Svar' height='46px' width='285px'
                    fontSize='16px' borderRadius='23px' border color='#898989'
                    hover='#4ec1e0' onClick={ () => history.push('/clientChat/faq/introduction') }
                    src='/images/downgrade.svg'/>
                )
            case 'faq':
            default:
                 return (
                    <SVGButton text='Uppgradera till Help Desk' height='46px' width='250px'
                    fontSize='16px' borderRadius='23px' border color='#898989'
                    hover='#4ec1e0' onClick={ () => history.push('/clientChat/faq/introduction') }
                    src='/images/upgrade.svg'/>
                )
        }
    }

    _renderMenu(){
        const RightMenuExchange = WithPaymentPermission('exchange')(MenuSubItem)
        // If we want to hide ratings section from non-pro users, use this:
        //const RatingStatsWithPayment = WithPaymentPermission('feature-rating')(MenuSubItem)
        return (
            <Flex column grow height='100%'>
                <MenuSubTitle
                    svgSrc='/images/Menu_ClientChatOptions.svg'
                    text='Client Chat'
                    onClick={this.props.onClick}
                    svgfill='#f64b7f'/>
                <Flex overflowY='auto' column>
                    <MenuSubItem
                        svgSrc='/images/Menu_ClientChatCustom_L.svg'
                        text='Utseende' to='/clientChat/customization'
                        svgfill='#f64b7f'/>
                    {this._renderHelpDeskMenuItem()}
                    <MenuSubItem
                        text='Offlineinställningar'
                        to='/clientChat/offlinesettings'
                        svgSrc='/images/Menu_ClientChatShowHide_L.svg'
                        svgfill='#f64b7f'/>
                    <MenuSubItem
                        text='Formulär & Återkoppling'
                        svgSrc='/images/Menu_ClientChatForms.svg'
                        to='/clientChat/formular'
                        svgfill='#f64b7f'/>
                    <MenuSubItem
                        text='Automeddelande'
                        svgSrc='/images/Menu_ClientChatAutomessage_L.svg'
                        to='/clientChat/autoMessage'
                        svgfill='#f64b7f'/>
                    <RightMenuExchange
                        text='Växelsystem'
                        svgSrc='/images/Menu_SwitchSystem_L.svg'
                        to='/clientChat/exchange'
                        svgfill='#f64b7f'/>
                    <MenuSubItem
                        svgSrc='/images/Menu_ratings.svg'
                        text={<span>Betyg & Omdömen<sup style={{color: 'purple', marginLeft: '1px'}}>PRO</sup><sup style={{color: 'red', marginLeft: '1px'}}> BETA</sup></span>} to='/clientChat/rating'
                        svgfill='#f64b7f'/>

                    <Flex color='black' vAlignContent='center' fontSize='16px' fontWeight='500' width='70%' ml='auto' pr='20px' pt='20px'>
                        <Flex h='60px' center mr='10px'>
                        Visa/Dölj på Hemsidan
                        </Flex>
                        <Flex h='60px' center fontWeight='500' fontSize='10px' mY='10px' column pt='10px'>
                            <ToogleSwitch
                                on={this.props.isClientChatAvailable}
                                manual={true}
                                onChange={this._openModal}
                                colorOff='red'
                            />
                            <Flex>
                            {this.props.isClientChatAvailable? 'online' : 'offline'}
                            </Flex>
                        </Flex>
                    </Flex>
                    <Flex grow hAlignContent='center' vAlignContent='bottom'
                        paddingBottom='20px'>
                        {this._renderUpgradeButton()}
                    </Flex>
                </Flex>
            </Flex>
        )
    }
    _renderModal(){
        return(
            <Flex w='600px' h='250px' overflow='hidden' borderRadius='20px' column>
                <Flex
                    w='100%' h='63px'
                    backgroundColor='#404040' color='blue'
                    center fontSize='28px' fontWeight='500'
                    borderBottom='5px solid'
                >
                    Är du säker?
                </Flex>
                <Flex grow column hAlignContent='center' w='100%'>
                    <Flex marginTop='30px' textAlign='center' fontSize='25px' fontWeight='300' center w='70%'>
                        Detta kommer stoppa alla
                        inkommande konversationer.
                    </Flex>
                    <Flex center mt='10px'>
                        <SVGButton onClick={this._closeModal} fontSize='27px' text='Tillbaka' height='50px' width='110px' border color='black' hover='#4ec1e0'/>
                        <Flex width='30px'/>
                        <SVGButton onClick={this._updateClientchat(false)} fontSize='27px' text='Dölj' height='50px' width='100px' border color='black' hover='#EF4129'/>
                    </Flex>
                </Flex>


            </Flex>
        )
    }
    render(){
        return(
            <Flex column grow>
                {this._renderMenu()}
                <Modal
                    styles={{
                        modal:{
                            width: '600px',
                            height: '250px',
                            borderRadius: '20px',
                            padding: '0px'
                        }
                    }}

                showCloseIcon={false} open={this.state.modalConfirmTurnOffClientChat} onClose={this._closeModal} center>
                    {this._renderModal()}
                </Modal>
            </Flex>
        )
    }

}

function mapStateToProps(state){
    const faqType = CustomizationSelector.getFaqType(state);
    let params = SystemSelector.getParams(state)

    return {
        isClientChatAvailable: CompanySelector.isClientChatAvailable(state, true),
        faqType: faqType,
        params: params
    }

}


export default withRouter(connect(mapStateToProps)(ClientChatMenu))



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/MainMenu/ClientChatMenu/index.js